module.exports = __webpack_public_path__ + "static/edel-396f305b5b6d631fe9c3f8fb05e9fe18.gif";